export async function requisitarFavoritos(api, jwt, { dados, consultar = false }) {
  if(!jwt.getToken()) { throw Object.assign(new Error("Confira a sessão antes de continuar."), { antesDoEnvio: true }); }
  api.setHeader();
  const { data } = await api.postOnce("atendimentos/access/" + (consultar ? "consultarFavoritosConfirmados" : "favoritosConfirmados"), dados, { timeout: 120000 });
  return data;
}
const id = value => /^[1-9]\d*$/.test(String(value));
export function respostaFavoritos(response, req) {
  return response?.contrato === "FAVORITOS_V1" &&
    ["ID_CLIENT_REQUEST", "ID_FICHA_DADOS_CAMPO", "ACAO"].every(k => String(response[k]) === String(req[k])) &&
    (!req.ID_ITEM || String(response.ID_ITEM) === String(req.ID_ITEM));
}
function confirmada(response, req) {
  return respostaFavoritos(response, req) && response.resultado === true && response.estado === "CONFIRMADO";
}
function registros(response, campo) {
  if(!Array.isArray(response.REGISTROS) || response.REGISTROS.some(r => !id(r?.ID_FICHA_DADOS_CAMPO_FAVORITO) ||
    String(r.ID_FICHA_DADOS_CAMPO) !== String(campo) || !("DESCRICAO" in r) || !("TITULO" in r) || !("ORDEM" in r)) ||
    new Set(response.REGISTROS.map(r => String(r.ID_FICHA_DADOS_CAMPO_FAVORITO))).size !== response.REGISTROS.length) {
    throw new Error("Não foi possível confirmar a lista de favoritos.");
  }
  return response.REGISTROS.map(r => ({ ...r, collapsed: true }));
}
const controls = new WeakMap();
export function favoritosEditor(vm, uuid) {
  if(controls.has(vm)) { return controls.get(vm); }
  let current = null, epoch = 0, destroyed = false;
  const slots = new Map();
  const visible = () => !!vm.$refs.modalFichaDadosFavoritos?.showModal;
  const active = (s, version = epoch) => !destroyed && current === s && version === epoch && visible();
  const request = (s, ACAO, extra = {}) => ({ ID_CLIENT_REQUEST: uuid(), ID_FICHA_DADOS_CAMPO: s.campo, ACAO, ...extra });
  function state(s) {
    if(!active(s)) { return; }
    vm.isLoading = s.loading;
    vm.listaPronta = s.ready;
    vm.erroLeitura = s.error;
    vm.gravacaoFavoritos = { ocupada: s.busy, pendente: !!s.pending, mensagem: s.message };
    vm.registros = s.rows;
    vm.incluindo = s.incluindo;
    vm.registroIncluindo = s.draft;
  }
  function capture() {
    if(current) { current.draft = vm.registroIncluindo; current.incluindo = vm.incluindo; }
  }
  async function load(s) {
    if(s.read) { return s.read; }
    const version = epoch, req = request(s, "LISTAR");
    s.loading = true; s.error = ""; state(s);
    const task = (async () => {
      await Promise.resolve();
      try {
        const response = await vm.requisitarFavoritos({ dados: req });
        if(!active(s, version)) { return false; }
        if(!confirmada(response, req)) { throw new Error("Não foi possível carregar os favoritos. Tente novamente."); }
        s.rows = registros(response, s.campo); s.ready = true; return true;
      } catch(error) {
        if(active(s, version)) { s.error = error.antesDoEnvio ? error.message : "Não foi possível carregar os favoritos. Tente novamente."; s.ready = false; }
        return false;
      } finally {
        if(s.read === task) { s.read = null; s.loading = false; state(s); }
      }
    })();
    s.read = task; return task;
  }
  async function send(s, consultar) {
    const req = s.pending, version = epoch;
    s.busy = true; s.message = consultar ? "Consultando resultado…" : "Confirmando alteração…"; state(s);
    try {
      let response;
      try { response = await vm.requisitarFavoritos({ dados: req, consultar }); }
      catch(error) {
        if(error.antesDoEnvio && !consultar && active(s, version)) { s.pending = null; s.message = error.message; return false; }
      }
      if(!active(s, version)) { return false; }
      if(!consultar && respostaFavoritos(response, req) && response.estado === "REJEITADO") {
        s.pending = null; s.message = response.mensagem || "A alteração não foi enviada. Seu preenchimento foi preservado."; return false;
      }
      if(!consultar && !confirmada(response, req)) {
        try { response = await vm.requisitarFavoritos({ dados: req, consultar: true }); } catch(error) { /* Somente consultar; nunca reenviar a escrita. */ }
      }
      if(!active(s, version)) { return false; }
      if(!confirmada(response, req)) { return false; }
      const rows = registros(response, s.campo);
      s.rows = rows; s.ready = true; s.error = ""; s.pending = null;
      if(req.ACAO === "INCLUIR") { s.draft = {}; s.incluindo = false; }
      s.message = req.ACAO === "INCLUIR" ? "Favorito salvo." : req.ACAO === "EXCLUIR" ? "Favorito excluído." : "Ordem atualizada.";
      return true;
    } catch(error) { return false; }
    finally {
      s.busy = false;
      if(s.pending) { s.message = "Alteração ainda não confirmada. Consulte o resultado antes de tentar outra alteração."; }
      state(s);
    }
  }
  const available = () => current && active(current) && current.ready && !current.busy && !current.loading && !current.pending;
  const c = {
    abrir(campo) {
      if(destroyed || !id(campo)) { return Promise.resolve(false); }
      if(current?.campo === String(campo) && visible() && current.open) {
        return current.read || Promise.resolve(current.ready);
      }
      capture(); epoch++;
      if(current) { current.open = false; current.read = null; current.loading = false; }
      const key = String(campo);
      if(!slots.has(key)) { slots.set(key, { campo: key, rows: [], draft: {}, incluindo: false, ready: false, busy: false, loading: false, error: "", message: "", pending: null }); }
      current = slots.get(key); current.open = true; vm.idFichaDadosCampo = key; state(current);
      if(current.pending || current.busy) { return Promise.resolve(false); }
      return load(current);
    },
    carregar() { return !current || current.busy || current.pending || !active(current) ? Promise.resolve(false) : load(current); },
    fechar() {
      capture(); epoch++;
      if(current) { current.open = false; current.read = null; current.loading = false; }
    },
    incluir(draft) {
      if(!available()) { return; }
      current.draft = draft; current.incluindo = true; current.message = ""; state(current);
    },
    cancelar() {
      if(!current || !active(current) || current.busy || current.pending) { return; }
      current.draft = {}; current.incluindo = false; current.message = ""; state(current);
    },
    async salvar() {
      if(!available()) { return false; }
      capture(); const s = current, version = epoch, d = s.draft;
      if(!id(d.ORDEM) || !String(d.TITULO || "").trim() || !String(d.CONTEUDO || "").trim()) {
        s.message = "Informe uma ordem positiva, título e conteúdo."; state(s); return false;
      }
      const dados = { ORDEM: String(d.ORDEM), TITULO: String(d.TITULO), DESCRICAO: String(d.CONTEUDO) };
      const prep = request(s, "PREPARAR"); s.busy = true; s.message = "Preparando inclusão…"; state(s);
      let response;
      try {
        response = await vm.requisitarFavoritos({ dados: prep });
        if(!active(s, version)) { return false; }
        if(!confirmada(response, prep) || !id(response.ID_ITEM)) { throw new Error(); }
      } catch(error) {
        s.message = "Não foi possível preparar a inclusão. Seu preenchimento foi preservado; tente novamente."; return false;
      } finally { s.busy = false; state(s); }
      s.pending = request(s, "INCLUIR", { ID_ITEM: String(response.ID_ITEM), DADOS: dados });
      return send(s, false);
    },
    excluir(row) {
      if(!available() || !current.rows.some(r => r === row || String(r.ID_FICHA_DADOS_CAMPO_FAVORITO) === String(row.ID_FICHA_DADOS_CAMPO_FAVORITO))) { return Promise.resolve(false); }
      current.pending = request(current, "EXCLUIR", { ID_ITEM: String(row.ID_FICHA_DADOS_CAMPO_FAVORITO) });
      return send(current, false);
    },
    ordenar(row, direction) {
      if(!available()) { return Promise.resolve(false); }
      const index = current.rows.findIndex(r => String(r.ID_FICHA_DADOS_CAMPO_FAVORITO) === String(row.ID_FICHA_DADOS_CAMPO_FAVORITO));
      const other = current.rows[index + direction];
      if(index < 0 || !other) { return Promise.resolve(false); }
      const itens = [current.rows[index], other].map(r => ({ ID: String(r.ID_FICHA_DADOS_CAMPO_FAVORITO), ORDEM: String(r.ORDEM) }));
      if(itens.some(r => !id(r.ORDEM)) || itens[0].ORDEM === itens[1].ORDEM) {
        current.message = "Há posições inválidas ou repetidas. Atualize a lista antes de ordenar."; state(current); return Promise.resolve(false);
      }
      current.pending = request(current, "ORDENAR", { ITENS: itens }); return send(current, false);
    },
    consultar() { return current && active(current) && current.pending && !current.busy ? send(current, true) : Promise.resolve(false); },
    podeEditar: available,
    invalidar() {
      c.fechar(); slots.clear(); current = null;
      vm.registros = []; vm.registroIncluindo = {}; vm.incluindo = false; vm.isLoading = false; vm.listaPronta = false; vm.erroLeitura = "";
      vm.gravacaoFavoritos = { ocupada: false, pendente: false, mensagem: "" };
      if(visible()) { vm.$refs.modalFichaDadosFavoritos.fecharModal(); }
    },
    destruir() { c.invalidar(); destroyed = true; }
  };
  controls.set(vm, c); return c;
}
